import clsx from 'clsx';
import React, { cloneElement, FC, ReactElement } from 'react';
import { HintProps } from '../hint';
import { Typography, TypographyProps } from '../typography';
import classes from './input-label.module.scss';

export type InputLabelProps = TypographyProps & {
  /**
   * If true, the label will render a required asterisk.
   */
  required?: boolean;

  hint?: ReactElement<HintProps>;
};

/**
 * A component that renders a label for an input field.
 */
export const InputLabel: FC<InputLabelProps> = ({ required, hint, ...props }) => {
  return (
    <Typography
      variant="label"
      as="label"
      {...props}
      className={clsx(classes.root, props.className, 'input-label-component')}
    >
      {props.children}
      {required && <Typography variant="label" as="span" color="grey.dark">&nbsp;*</Typography>}
      {hint && cloneElement(hint, { ...hint.props, className: clsx(hint.props.className, classes.hint) })}
    </Typography>
  );
};
